    window.Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ],
    error => {
      if (error) {
        // Rescue error
      }
      // If error is false, the API has loaded and ready to use!
      window.Shopify.customerPrivacy.setTrackingConsent(
        {
          "analytics":     false,
          "marketing":     false,
          "preferences":  false,
          "sale_of_data": false

        },
        () => console.log("Consent captured")
      );
    },
   );

   
   (() => {
    "use strict";
    var n = function () {
      var n;
      return !("string" != typeof window.OnetrustActiveGroups || null == (n = window.Shopify) || !n.customerPrivacy) && (t(), window.OptanonWrapper = t, true);
    }, t = function () {
      var n = window, t = n.OnetrustActiveGroups, r = n.Shopify, i = {analytics: !!t.includes("C0002"), marketing: !!t.includes("C0004")};
      r.customerPrivacy.setTrackingConsent(i, function () {});
    };
    !function () {
      n();
      var t = 0, r = setInterval(function () {
        (n() || t > 100) && clearInterval(r), t++;
      }, 100);
    }();
  })();
  